import React from 'react';

import isEmpty from 'lodash-es/isEmpty';

import { FlexBox, FlexBoxColumn, FlexBoxSpaceBetween, ImageBox } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import { InnerButton } from '@ecp/common/src/components/button/Button';
import { TextButton } from '@ecp/common/src/components/button/TextButton';

import useSiteInfo from '@fo-hooks/common/useSiteInfo';
import { StyledTextBox, StyledAtag } from '@ecp/fo/sites/skypass/styles/footer/SkypassFooterBottomStyles';

export default function SkypassFooterBottom() {
  const {
    systemInformation: { pcFooterImgFilePath, customerCenterTel, customerCenterGuide, resdEmail },
    operationTime,
    lunchTime,
  } = useSiteInfo();

  const handleBusinessInfoClick = () => {
    window.open('https://www.ftc.go.kr/www/bizContents.do?key=253');
  };

  function onClickMailTo() {
    const emails = 'mailTo:' + resdEmail;
    window.location.href = emails;
  }

  return (
    <FlexBoxSpaceBetween width={'1540px'} height={'270px'} align-items={'flex-start'}>
      <FlexBox gap={'20px'} align-items={'flex-start'}>
        <ImageBox
          imageSrc={pcFooterImgFilePath}
          width={'80px'}
          height={'57px'}
          backgroundPositionY={'top'}
          background-size={'contain'}
        />
        <FlexBoxColumn align-items={'flex-start'}>
          <Spacing top={6} bottom={20}>
            <TextBox size={'13px'} weight={'500'}>
              알아두세요
            </TextBox>
            <StyledTextBox>
              • 구매 전 보유 마일리지를 확인해주시기 바랍니다.{' '}
              <StyledAtag
                target="_blank"
                title="새 창 열림"
                rel="noreferrer"
                size={'13px'}
                weight={'500'}
                href="https://www.koreanair.com/my-mileage/overview"
                style={{ textDecoration: 'underline' }}
              >
                마일리지 현황&gt;
              </StyledAtag>
            </StyledTextBox>
            <StyledTextBox>• 대한항공 홈페이지 회원 가입 및 로그인 후 이용 가능합니다.</StyledTextBox>
            <StyledTextBox>• 본인의 보유 마일리지만 사용할 수 있으며, 가족합산은 불가합니다.</StyledTextBox>
            <StyledTextBox>
              • 상품 구매취소나 환불 시, 유효기간이 지난 마일리지는 소멸되어 환급되지 않습니다.
            </StyledTextBox>
            <StyledTextBox>• 준비된 수량이 모두 판매되면 안내된 기간 전에 종료될 수 있습니다.</StyledTextBox>
            <StyledTextBox>• 자세한 내용은 상품 상세 페이지를 참고해주세요.</StyledTextBox>
          </Spacing>

          <FlexBox justify-content={'flex-start'} gap={'20px'}>
            <StyledTextBox>(주) 대한항공 대표이사 우기홍 외 1명</StyledTextBox>
            <StyledTextBox>서울특별시 강서구 하늘길 260</StyledTextBox>
            <StyledTextBox>문의전화 {customerCenterTel}</StyledTextBox>
            <StyledTextBox>
              이메일&nbsp;
              <TextButton
                textProps={{
                  weight: '350',
                  size: '13px',
                }}
                onClick={onClickMailTo}
              >
                {' '}
                {isEmpty(resdEmail) ? '' : resdEmail}
              </TextButton>
            </StyledTextBox>
          </FlexBox>
          <FlexBox justify-content={'flex-start'} gap={'20px'}>
            <StyledTextBox>호스팅 사업자 : 삼성SDS(주)</StyledTextBox>
            <StyledTextBox gap={'5px'}>
              사업자등록번호 110-81-14794
              <InnerButton
                width={'66px'}
                height={'20px'}
                style={{ padding: '0', borderRadius: '0' }}
                onClick={handleBusinessInfoClick}
              >
                <TextBox size={'12px'} weight={350}>
                  <StyledAtag
                    href="https://www.ftc.go.kr/www/bizContents.do?key=253"
                    target="_blank"
                    title="새 창 열림"
                    rel="noreferrer"
                  >
                    사업자 확인
                  </StyledAtag>
                </TextBox>
              </InnerButton>
            </StyledTextBox>
            <StyledTextBox>통신판매업 신고번호(제 2006-16-3010호)</StyledTextBox>
          </FlexBox>
          <FlexBox justify-content={'flex-start'} gap={'20px'}>
            <StyledTextBox>개인정보보호책임자 : 최희정 상무</StyledTextBox>
          </FlexBox>
        </FlexBoxColumn>
      </FlexBox>
      <FlexBoxColumn align-items={'flex-start'}>
        <TextBox weight={'350'} height={'22px'}>
          고객센터
        </TextBox>
        <TextBox size={'28px'} weight={'500'} height={'45px'}>
          {customerCenterTel}
        </TextBox>
        <Spacing top={6} />
        <TextBox weight={'350'}>
          {operationTime} {lunchTime}
          <br />
          {customerCenterGuide}
        </TextBox>
      </FlexBoxColumn>
    </FlexBoxSpaceBetween>
  );
}
